import { render, staticRenderFns } from "./LoginSection.vue?vue&type=template&id=cb94855c&scoped=true"
import script from "./LoginSection.vue?vue&type=script&lang=ts"
export * from "./LoginSection.vue?vue&type=script&lang=ts"
import style0 from "./LoginSection.vue?vue&type=style&index=0&id=cb94855c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb94855c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb94855c')) {
      api.createRecord('cb94855c', component.options)
    } else {
      api.reload('cb94855c', component.options)
    }
    module.hot.accept("./LoginSection.vue?vue&type=template&id=cb94855c&scoped=true", function () {
      api.rerender('cb94855c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginSection.vue"
export default component.exports